import { stdObject } from "../data/types/stdObject";
import { getType } from "../screens/MainStructure/SearchBar/data/searchItemUtils";

export const getInputType = (
  CODCAB: string,
  base: string,
  type: string,
  option: stdObject,
) => {
  let tempData: stdObject = {};
  switch (CODCAB) {
    case "PREART":
    case "ALMART":
    case "PREPCO":
    case `NET${base}`:
    case `IMP${base}`:
    case `TOT${base}`:
    case `SAL${base}`:
    case `ABO${base}`:
    case `CAD${base}`:
    case "BULART":
      tempData.type = "numberRange";
      tempData.isMultiNumber = true;
      if (["PREART", "ALMART"].includes(CODCAB)) {
        tempData.option = option;
      }
      break;
    // case "SERART":
    case "ENSART":
    case "EDIART":
    case "FAMART":
    case `WHA${base}`:
    case `WEB${base}`:
    case `GPS${base}`:
    case `ADJ${base}`:
    case "OTRART":
    case `NAC${base}`:
    case `EST2${base}`:
    case `EST3${base}`:
    case `PSE${base}`:
    case `TIM${base}`:
    case `PAG${base}`:
      tempData.option = "";
      if ([`EST2${base}`, `EST3${base}`, "FAMART"].includes(CODCAB)) {
        tempData.isMultiSelect = true;
      }
      break;
    case "FCRART":
    case "FLLART":
    case "FMOART":
    case `FEC${base}`:
    case `FEC2${base}`:
      tempData.type = "date";
      tempData.isMultiDate = true;
      break;
    default:
      tempData.type = getType(CODCAB, type);
  }
  return tempData;
};
